import React from 'react';
import UISpinner from 'Components/UIComponents/UISpinner';

export interface MobileButtonProps {
  handleClick: () => void;
  title: string;
  disabled?: boolean;
  isLoading?: boolean;
}

export const SigningButtonMobile = ({
  handleClick,
  title,
  disabled = false,
  isLoading = false,
}: MobileButtonProps) => {
  return (
    <button className="next-btn-mobile" onClick={handleClick} disabled={disabled}>
      {isLoading && <UISpinner wrapperClassName="button__spinner" />}
      <p>{title}</p>
    </button>
  );
};
